import {useI18n} from "./i18n";
import {useId,useState} from "react";
import {diagnosticCatalog} from "./diagnosticCatalog";
import {diagnosticErrorText,errorDiagnostic,formatDiagnostic,type DiagnosticRecord} from "./diagnosticMessage";

export function DiagnosticText({value}:{value?:DiagnosticRecord}){
 const {t}=useI18n();if(!value)return null;
 const code=value.diagnostic?.code;
 return <>{code?<span>{formatDiagnostic(value.diagnostic,t)}</span>:value.message?<span>{t("历史诊断记录","Historical diagnostic")}</span>:null}
 {(!code||!diagnosticCatalog[code])&&value.message?<OriginalDiagnostic text={value.message}/>:null}</>;
}
function OriginalDiagnostic({text}:{text:string}){const {t}=useI18n();const [open,setOpen]=useState(false);const id=useId();return <span><button type="button" className="text-button" aria-expanded={open} aria-controls={id} onClick={()=>setOpen(!open)}>{open?t("收起原始诊断","Hide original diagnostic"):t("查看原始诊断","View original diagnostic")}</button><span id={id} hidden={!open} style={{whiteSpace:"pre-wrap",overflowWrap:"anywhere"}}>{text}</span></span>}
export function DiagnosticError({error}:{error:unknown}){
 const {t}=useI18n();const diagnostic=errorDiagnostic(error);
 const original=error instanceof Error?error.message:undefined;
 return <>{diagnosticErrorText(error,t)}{diagnostic?.code&&!diagnosticCatalog[diagnostic.code]&&original&&original!==diagnostic.code?<OriginalDiagnostic text={original}/>:null}</>;
}
